export default __webpack_public_path__ + "static/Lato-Bold-636be8de934918e38ed94b9d68e67fe0.ttf";